// extracted by mini-css-extract-plugin
export default {"productImg":"AdminMobileAllStoreSaleList_productImg__xdyqG","list":"AdminMobileAllStoreSaleList_list__wJOf4"};